import { useCKFilterContext } from "./CKFilterContext";

export interface CKFilterResetButtonProps<T> {
  children({
    onReset,
  }: {
    onReset: () => void;
    value: T[];
  }): React.ReactElement;
}

export const CKFilterReset = <T extends any>({
  children,
}: CKFilterResetButtonProps<T>) => {
  const { onReset, value } = useCKFilterContext<T>();
  return children({ onReset, value });
};
